import React, { Component } from "react";
import Images from "../../Images";

export class Promos extends Component {
  render() {
    const {promo , history}=this.props
    return (
      <div className="promos-slide">
        <div className="promo-item">
          <img src={`${promo.promoPath}?id=${promo.imageVersion}`} onClick={()=>history.push(`/promos/${promo.promoId}`)}/>
          <h3>{promo.name}</h3>
          {/* <p>
            No bet has been selected. To select select To select select a bet…
          </p> */}
        </div>
      </div>
    );
  }
}

export default Promos;
